export interface LocationActivityLog {
  id: string;
  location: {
    id: string;
    name: string;
  };

  type: string;
  details: any;
  activity_date: Date;
  created_at: Date;

  created_by?: {
    id: string;
    name: string;
  };

  relatedContent?: any;
}

export enum LocationActivityLogType {
  NEW_REVIEW = "new_review",
  REVIEW_REPLY = "review_reply",
  NEW_LOCAL_POST = "new_local_post",
  NEW_MEDIA = "new_media",
  PICKUP_FIELD_CHANGE = "pickup_field",
  HEALTH_INDEX_CHANGE = "health_index_change"
}
